/* created by CoolGuy on 2018/12/13 */
import React from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, computed } from 'mobx';
import imageUtil from '../../utils/image.js';
import { isIphoneX } from '../../utils/util.ts';
import moment from 'moment';
import intl from 'react-intl-universal';
import { createPortal } from 'react-dom';
import ReturnIcon from '../../components/Common/ReturnIcon';
import { pushHistory, popHistory } from '../../utils/history';
import './index.scss';

const OnePeople = ({ nickname, photo, amount, best, createtime }) => {
  return (
    <div className="one-people bb">
      <img src={photo} alt="" className="one-people-avatar" />
      <div className="contents">
        <div className="row1">
          <div className="one-people-name">{nickname}</div>
          <div className="one-people-money">
            {(amount / 100).toFixed(2)}
            {intl.get('CNY')}
          </div>
        </div>
        <div className="row2">
          <div className="one-people-time">{moment(createtime).fromNow()}</div>
          {!!best && (
            <div className="the-best-luck">
              <i className={'crown'} />
              <div style={{ marginLeft: 3, color: '#FFBB28' }}>
                {intl.get('Luckiest Draw')}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

@inject('rootStore')
@observer
class RedPackDetail extends React.Component {
  @observable page = 1;
  @observable total = 0;
  @observable list = [];
  @observable current = {};
  @observable redpackage = {};
  @observable dataGet = false;
  constructor(props) {
    super(props);
    this.containerEle = document.createElement('div');
  }
  getDetail = () => {
    const { redPackStore } = this.props.rootStore;
    const { redPackDetailId } = redPackStore;
    return redPackStore.getOneRedPackDetail(redPackDetailId, this.page).then(
      action(jsonData => {
        // console.log(jsonData);
        const { total, data } = jsonData;
        const { list, current, redpackage } = data || {};
        this.list = this.list.concat(list);

        this.current = current;
        if (this.page == 1) {
          this.redpackage = redpackage || {};
          this.total = total;
        }
        this.page++;
        this.dataGet = true;
      })
    );
  };
  getRealPhoto = photo => {
    if (!photo) {
      return '';
    }
    if (photo.indexOf('http') === 0 || photo.indexOf('//') === 0) {
      return photo;
    }
    return imageUtil.style(photo, 'redpackage_logo');
  };

  @computed get listTotalAmount() {
    const { list } = this;
    if (!list || !list.length) {
      return 0;
    }
    return list.reduce((sum, one) => one.amount - 0 + sum, 0);
  }

  @computed get formatListTotalAmount() {
    return (this.listTotalAmount / 100).toFixed(2);
  }

  componentWillUnmount() {
    document.body.removeChild(this.containerEle);
  }

  componentDidMount() {
    document.body.appendChild(this.containerEle);
    this.getDetail();

    pushHistory('redpackdetail', ()=>{
      this.close();
    });
  }

  loadMore = () => {
    this.getDetail();
  };
  close = () => {
    this.props.rootStore.redPackStore.setRedPackDetailModal(0, false);
  };

  render() {
    const { total, current, redpackage, dataGet } = this;
    const { nickname, photo, amount } = current;
    if (!dataGet) {
      return null;
    }
    return createPortal(
      <div className="red-pack-detail">
        <img
          src={require('../../assets/redpack/detail-bg.png')}
          className="bg"
          alt=""
        />
        <div className="part1">
          <img
            src={this.getRealPhoto(redpackage.photo)}
            alt=""
            className="avatar"
          />
          <div className="name">
            {redpackage.nickname}
            {intl.get("'s red packet")}{' '}
            {redpackage.type == 'luck' ? <div className="pin">拼</div> : null}
          </div>
          <div style={{ fontSize: 16 }}>
            {intl.get("Red packet's coming! ")}
          </div>
          <div className="money">
            {(amount / 100).toFixed(2)}
            <span style={{ marginLeft: 5, fontSize: 18 }}>
              {intl.get('CNY')}
            </span>
          </div>
          <div style={{ color: '#5071B0', fontSize: 12 }}>
            {intl.get('Red Packet transferred to Wallet')}
          </div>
        </div>
        {this.list.length == redpackage.number ? (
          <div className="title bb">
            {intl.get('Red Packet total num and money', {
              n: redpackage.number,
              money: (redpackage.amount / 100).toFixed(2)
            })}
          </div>
        ) : (
          <div className="title bb">
            {intl.get('Opened and total', {
              n1: this.total || 0,
              n2: redpackage.number,
              n3: ((redpackage.goted * 1) / 100).toFixed(2),
              n4: (redpackage.amount / 100).toFixed(2)
            })}
          </div>
        )}

        <div className="red-pack-list list">
          {current && Number(current.amount) ? (
            <OnePeople key={0} {...current} />
          ) : null}
          {this.list.map((one, index) =>
            one && current && one.openid != current.openid ? (
              <OnePeople key={index} {...one} />
            ) : null
          )}
          {this.list.length < total ? (
            <div
              className={'load-more ' + (isIphoneX() ? 'ipx' : '')}
              onClick={this.loadMore}
            >
              {intl.get('Load more')}
            </div>
          ) : (
            <div
              className={'load-more ' + (isIphoneX() ? 'ipx' : '')}
              style={{ marginTop: 10 }}
            >
              {intl.get('This is the end', { words: '' })}
            </div>
          )}
        </div>
        <div className="return-wrapper">
          <ReturnIcon onClick={()=>{
            popHistory();
            this.close();
          }} />
        </div>
      </div>,
      this.containerEle
    );
  }
}
export default RedPackDetail;
